export default __webpack_public_path__ + "static/media/LT.bf71f70d.svg";